/**
 * Mapeo de tipo de aeronave DCS → silueta SVG — Fase 5g.3.
 *
 * El campo `aircraft` de un apontaje viene de `initiator.type` del
 * debrief de DCS (p.ej. `FA-18C_hornet`, `F-14B`, `A-4E-C`, `F4U-1D`).
 * Las siluetas viven en `web/public/aircraft/<slug>.svg` (Fase 5g.2,
 * commit bad7b0e): a4, a6m, f4, f4u, f6f, f14, f18 — un único `path`
 * negro sobre fondo transparente, pensado para recolorear vía
 * `mask-image` + `background-color`.
 */

interface SilhouetteRule {
  /** Patrón aplicado sobre el string crudo de `initiator.type`. */
  test: RegExp;
  /** Slug del archivo en `/aircraft/<slug>.svg`. */
  slug: string;
}

/**
 * Reglas en orden de prioridad — la primera que casa gana. El orden
 * importa: `F4U` y `F-14`/`F-18` deben comprobarse antes que `F-4`,
 * que es subcadena de los tipos Phantom (`F-4E-45MC`).
 */
const RULES: SilhouetteRule[] = [
  { test: /F4U|CORSAIR/i, slug: 'f4u' },
  { test: /F6F|HELLCAT/i, slug: 'f6f' },
  { test: /A6M|ZERO|ZEKE/i, slug: 'a6m' },
  { test: /FA-?18|F\/A-18|F-18|HORNET/i, slug: 'f18' },
  { test: /F-?14|TOMCAT/i, slug: 'f14' },
  { test: /A-?4|SKYHAWK/i, slug: 'a4' },
  { test: /F-?4|PHANTOM/i, slug: 'f4' },
];

/**
 * Devuelve el slug de silueta para un tipo DCS, o `null` si no hay
 * mapeo conocido (el caller pinta un placeholder genérico).
 */
export function silhouetteSlug(aircraft: string | null): string | null {
  if (!aircraft) return null;
  for (const rule of RULES) {
    if (rule.test.test(aircraft)) return rule.slug;
  }
  return null;
}

/**
 * URL de la silueta lista para usar como `mask-image`, o `null` si el
 * tipo no está mapeado.
 */
export function silhouetteUrl(aircraft: string | null): string | null {
  const slug = silhouetteSlug(aircraft);
  return slug ? `/aircraft/${slug}.svg` : null;
}
